var ProductReviews;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (ProductReviews.Templates == null) {
  ProductReviews.Templates = {};
}

ProductReviews.Templates['product_reviews_review_card'] = require('../../review_card.html.mustache');

ProductReviews.Views.ReviewCard = Backbone.View.extend({
  events: {
    'click .read-more': 'toggleReadMore'
  },
  initialize: function() {
    var ref;
    if ((ref = this.model.displayOptions) != null ? ref.readMoreEnabled : void 0) {
      return this.listenTo(this.model, 'change:reviewTextHeight', this.updateReadMore);
    }
  },
  render: function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      displayOptions: this.model.displayOptions,
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    this.$el.append(ProductReviews.Templates['product_reviews_review_card'].render(data));
    this.$readMore = this.$el.find('.read-more');
    return this.$reviewText = this.$el.find('.review-text-container');
  },
  updateReadMore: function() {
    return this.$reviewText.toggleClass('show', this.model.shouldShowReadMore());
  },
  toggleReadMore: function() {
    if (this.$reviewText.hasClass('expanded')) {
      this.$reviewText.removeClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_more'));
    } else {
      this.$reviewText.addClass('expanded');
      return this.$readMore.text(I18n.t('js.modules.product_reviews.review_card.read_less'));
    }
  }
});

module.exports = ProductReviews.Views.ReviewCard;

//# sourceMappingURL=data:application/json;base64,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
